export const STATUS_EXAMPLE = {
  1: '1',
  0: '0'
}

export const TYPE_PROPORTION = {
  ARRANGE_CLASS_REGULAR: 'ARRANGE_CLASS_REGULAR',
  ARRANGE_CLASS_DEMO: 'ARRANGE_CLASS_DEMO',
  ARRANGE_MAKE_UP_SESSION: 'ARRANGE_MAKE_UP_SESSION',
  CHANGE_CLASS_REGULAR_TEACHER: 'CHANGE_CLASS_REGULAR_TEACHER',
  CHANGE_SESSION_REGULAR_TEACHER: 'CHANGE_SESSION_REGULAR_TEACHER',
}

export const URL_API = {
  ASSIGN_COORDINATOR: 'api/calendar/demo/coordinator'
}

// File mẫu import Danh sách ticket nhận xét lớp học
export const LINK_IMPORT_SAMPLE_REVIEW_DEMO = 'https://docs.google.com/spreadsheets/d/1T634kZyTFTaJM2-YiERo70QRK066Jr_QeCTzI2Rzt1Q/edit?gid=1573488747#gid=1573488747'
